module.exports = __webpack_public_path__ + "img/lg_ring_g_skip_1_1@3x.9558a57d.png";